import { render, staticRenderFns } from "./DocParametrage.vue?vue&type=template&id=c1386f80&"
import script from "./DocParametrage.vue?vue&type=script&lang=js&"
export * from "./DocParametrage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports